// src/lib/env.ts
function asBool(v: unknown) {
  return String(v).trim().toLowerCase() === 'true';
}

const RAW_FEATURE = import.meta.env.VITE_FEATURE_IAP;
const RAW_ENABLED = import.meta.env.VITE_IAP_ENABLED;

export const IAP_ENABLED =
  asBool(RAW_FEATURE ?? RAW_ENABLED); // supports either name

export const RC_PUBLIC_KEY =
  (import.meta.env.VITE_REVENUECAT_PUBLIC_API_KEY as string) || '';

/** Loud diagnostics in dev so this never bites you again */
if (import.meta.env.DEV) {
  // Warn if both vars exist and disagree
  if (RAW_FEATURE !== undefined && RAW_ENABLED !== undefined && asBool(RAW_FEATURE) !== asBool(RAW_ENABLED)) {
    // eslint-disable-next-line no-console
    console.warn('[ENV] VITE_FEATURE_IAP and VITE_IAP_ENABLED both set and differ. Using truthy-merge result:', IAP_ENABLED);
  }
  // eslint-disable-next-line no-console
  console.log('[ENV] IAP_ENABLED:', IAP_ENABLED, 'RC_PUBLIC_KEY set:', !!RC_PUBLIC_KEY);
}